/**
 * Shared class strings for the Billing tab, so its buttons and bill table read
 * like the rest of the inventory app.
 */

/** DESIGN.md §3.4 primary CTA: filled brand purple. */
export const PRIMARY_ACTION_CLASS =
  'h-8 gap-1.5 bg-threadheads-purple px-3 text-xs text-white hover:bg-threadheads-purple/90';
/** DESIGN.md §3.4 secondary / auxiliary: outline. */
export const SECONDARY_ACTION_CLASS = 'h-8 gap-1.5 px-3 text-xs';

/**
 * The 3PL bill's table classes (`features/reporting/components/ThreePlBill.tsx`),
 * so the two bills in the app are one look. Below `sm` cells pad less and the
 * number columns take their content's width, so Charge keeps room for words
 * and four columns fit a phone without the bill scrolling sideways.
 */
export const NUMBER_TD = 'px-2 py-2.5 text-right align-top sm:px-4';
export const NUMBER_TH =
  'whitespace-nowrap px-2 py-2 text-right text-xs font-medium text-muted-foreground sm:px-4';
export const CHARGE_TD = 'px-3 py-2.5 [overflow-wrap:anywhere] sm:px-4';
export const TEXT_TH = 'px-3 py-2 text-left text-xs font-medium text-muted-foreground sm:px-4';
/** A grey line under a title: capped at a readable measure. */
export const DETAIL_P = 'max-w-prose whitespace-normal text-xs text-muted-foreground';
/** A card's outer shell: the 3PL bill's bordered section, no shadow. */
export const CARD_CLASS = 'rounded-lg border bg-card';
